import { render, staticRenderFns } from "./ExpirySummary.vue?vue&type=template&id=a827828c&scoped=true"
import script from "./ExpirySummary.vue?vue&type=script&lang=js"
export * from "./ExpirySummary.vue?vue&type=script&lang=js"
import style0 from "./ExpirySummary.vue?vue&type=style&index=0&id=a827828c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a827828c",
  null
  
)

export default component.exports